import { getDeviceKey, saveDeviceKey } from "@/storage/authentication";

export class AuthHelpers {
  static uuid(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // convert number of seconds to a hh:mm:ss.x string
  static secondsToTime(totalSeconds: number): string {
    const pad = (num: number, size = 2) => ("000000000" + num).substr(-size);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const fraction = Math.ceil(
      (totalSeconds < 1.0 ? totalSeconds : totalSeconds % Math.floor(totalSeconds)) * 10,
    );

    return `${hours}:${pad(minutes)}:${pad(seconds)}.${fraction}`;
  }

  static getGetOrCreateKey(name: string): string {

    let deviceKey = getDeviceKey(name)
    if (deviceKey) {
      return deviceKey;
    }

    deviceKey = this.generateKey();
    saveDeviceKey(name, deviceKey)

    return deviceKey;
  }

  static generateKey(): string {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return this.toBase64(array);
  }

  static toBase64(buffer: Uint8Array<ArrayBuffer>): string {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}
